import { Upload } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
const Dragger = Upload.Dragger;
export const UploadFileDragger = props => {
    const { accept, customRequest, children } = props;
    return /*#__PURE__*/ _jsx(Dragger, {
        accept: accept,
        customRequest: customRequest,
        children: children
    });
};
